import { render, staticRenderFns } from "./OrderCheckout.vue?vue&type=template&id=4e00472b&scoped=true"
import script from "./OrderCheckout.vue?vue&type=script&lang=js"
export * from "./OrderCheckout.vue?vue&type=script&lang=js"
import style0 from "./OrderCheckout.vue?vue&type=style&index=0&id=4e00472b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e00472b",
  null
  
)

export default component.exports